





































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { each, isInteger } from 'lodash'
import { camelizeKeys } from '@/utils'

import Process from '@/components/workflow/Process.vue'
import Task from '@/components/workflow/Task'
import Timer from '@/components/workflow/Timer'
import { kebabToCamelCase } from '@/utils'
import AssessmentMixin from './AssessmentMixin'

export default mixins(AssessmentMixin).extend({
  components: {
    CommonPost: require('./CommonPost.vue').default,
    Process,
    Task,
    Timer,
  },
})
